// Add your JS customizations here
import Swiper from 'swiper';
import { Autoplay, Navigation, EffectFade, Pagination, Manipulation } from 'swiper/modules';
import AOS from 'aos';

AOS.init({
	duration: 700,
	once: true,
	disable: 'mobile',
});

// 100 viewport width fix
function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
setVw();
window.addEventListener('resize', setVw);

// Sticky header
const headerEl = document.querySelector('#site-header');
const sentinalEl = document.querySelector('.header-sentinel');
const handler = (entries) => {
	if (!entries[0].isIntersecting) {
		headerEl.classList.add('is-sticky');
		headerEl.classList.remove('animated');
		headerEl.classList.add('animated');
	} else {
		headerEl.classList.remove('is-sticky');
		headerEl.classList.remove('animated');
		headerEl.classList.add('animated');
	}
}
const observer = new window.IntersectionObserver(handler);
observer.observe(sentinalEl);

const visualViewport = window.visualViewport;
if (visualViewport) {
	const initialHeight = window.visualViewport.height;
	visualViewport.addEventListener("resize", (event) => {
		if(initialHeight > window.visualViewport.height) {
			headerEl.classList.add('is-sticky');
			headerEl.classList.remove('animated');
			headerEl.classList.add('animated');
		}
	});
}


jQuery(function($){

	// Scroll Down button
	$('.scroll-down-btn').click(function(){
		$('.homepage-hero').next()[0].scrollIntoView();
	});

	// Move all modals to the bottom
	$('.modal').appendTo('body');

	$('.full-width-bg-block + .full-width-bg-block').each(function(){
		let prevItem = $(this).prev().addClass('has-next-same-type');
	});

	// "Expand All" button
	$('#site-main').on('click', '.accordion-toggle-all-btn', function(e){
		e.preventDefault();
		let $this = $(this);
		if($this.hasClass('expanded')) {
			$this.closest('.accordions-wrap').find('.collapse').collapse('hide');
			$this.removeClass('expanded');
		} else {
			$this.closest('.accordions-wrap').find('.collapse').collapse('show');
			$this.addClass('expanded');
		}
	});

	// Autoplay video on modal
	$('.modal iframe').each(function(){
		let $this = $(this);
		let src = $this.attr('src') + '&autoplay=1';
		let theModal = $this.closest('.modal');
		$(this).attr('src', '');

		theModal.on('show.bs.modal', function() {
			$this.attr('src', src);
		});

		theModal.on('hide.bs.modal', function() {
			$this.attr('src', '');
		});
	});

	// Email disclaimer popup
	$('.email-link').click(function(e){
		e.preventDefault();
		let disclaimerModal = $('#email-disclaimer');
		let emailAddress = $(this).data('email');
		disclaimerModal.find('.confirm-link').attr('href', 'mailto:' + emailAddress);
		console.log(disclaimerModal.find('.confirm-link'));
		disclaimerModal.modal('show');
	});

	// Selectric
	$('select').selectric({
		forceRenderBelow: true,
		optionsItemBuilder: function(itemData) {
			if($(itemData.element).data('subitem')) {
				return '<span class="sub-item">' + itemData.text + '</span>';
			}
			return itemData.text;
		},
		disableOnMobile: false,
		nativeOnMobile: false,
	});

	$(document).on('gform_page_loaded', function(){
		$('select').selectric({
			forceRenderBelow: true,
			optionsItemBuilder: function(itemData) {
				if($(itemData.element).data('subitem')) {
					return '<span class="sub-item">' + itemData.text + '</span>';
				}
				return itemData.text;
			}
		});
	});

	// Mobile nav
	$('.btn-toggle-menu').click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('.site-header').toggleClass('header-mobile-expanded');
		$('body').toggleClass('mobile-menu-open');
	});

	// Homepage hero video
	$('.video-hero').each(function(){
		const $this = $(this);
		const mp4 = $this.data('mp4');
		const webm = $this.data('webm');

		const maxMobile = 1200;

		function appendVideo() {
			let currentWindowWidth = $(window).width();
			$this.empty();
			if(currentWindowWidth > maxMobile ) {
				if(webm) {
					$this.append('<source src="' + webm + '" type="video/webm">');
				}
				if(mp4) {
					$this.append('<source src="' + mp4 + '" type="video/mp4">');
				}
			}
		}
		appendVideo();
	});


	function setVarLabelWidth(selector) {
		$(selector).each(function(){
			if($(this).closest('a, button').length) {
				$(this).closest('a, button')[0].style.setProperty('--label-width', `${$(this)[0].getBoundingClientRect().width + 5}px`);
			}
		});
	}
	setVarLabelWidth('.link-label .label-inner');
	$(window).on('resize', () => setVarLabelWidth('.link-label .label-inner'));
	$('.list-with-accordion .collapse').on('shown.bs.collapse', function(){
		setVarLabelWidth($(this).find('.link-label .label-inner'));
	});


});

// Sliders
// Author slider
const authorSlider = document.querySelectorAll('.authors-slider');
authorSlider.forEach(wrapper => {

	const authorSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		modules: [ Navigation, EffectFade, Autoplay ],
		speed: 700,
		preventInteractionOnTransition: true,
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		},
	});
});


const experienceSlider = document.querySelectorAll('.featured-experience-row');
experienceSlider.forEach(wrapper => {

	const experienceSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		slidesPerView: 1,
		modules: [ Navigation ],
		speed: 700,
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		},
	});
});

const calloutSlider = document.querySelectorAll('.callout-slider');
calloutSlider.forEach(wrapper => {

	const calloutSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		slidesPerView: 1,
		modules: [ Pagination ],
		speed: 700,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
});


const testimonialSlider = document.querySelectorAll('.testimonial-slider');
testimonialSlider.forEach(wrapper => {
	const testimonialSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		slidesPerView: 1,
		modules: [ Pagination, EffectFade, Autoplay ],
		speed: 700,
		effect: 'fade',
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	});
});


/* Search AutoComplete
------------------------------------------------ */
(function($) {

	function outputLi(result) {
		return '<li><a href="' + result.url + '">' + result.title + '</a></li>';
	}

    $.fn.autoKomplete = function(options) {
		var el = this, keyTimer, previousValue;
		var btnIcon = el.siblings('button').find('i');

		var resultsEl = $('<div class="live-search-results" style="display:none"></div>');
		var thisForm = $(el).closest('form');
		resultsEl.insertAfter(el);

		var opt = $.extend({
			type: false
        }, options );

		el.on('keyup', function(){

			if(previousValue != el.val()) {
				clearTimeout(keyTimer);

				if(el.val() && el.val().length >= 2) {
					keyTimer = setTimeout(getResults, 700);
				} else {
					btnIcon.removeClass('fa-spinner-third fa-spin');
					resultsEl.fadeOut(200).html('');
					thisForm.addClass('no-live-search-results');
				}

			}
			previousValue = el.val();

		});

		function getResults() {
			btnIcon.addClass('fa-spinner-third fa-spin');
			btnIcon.closest('button').addClass('clear-filter-btn').attr('type', 'reset');

			var jsonURL = ajax_var.rest_url + 'jgl/v1/search?term=' + el.val();
			if(opt.type) {
				jsonURL += '&type=' + opt.type;
			}
			$.getJSON(jsonURL, (results) => {

				var output = '';
				thisForm.addClass('no-live-search-results');

				if(results.attorneys.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="lsr-group">';
					output += '<div class="lsr-group-title">Attorneys</div><ul>';
					$.each(results.attorneys, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(results.services.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="lsr-group">';
					output += '<div class="lsr-group-title">Services</div><ul>';
					$.each(results.services, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(results.class_actions.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="lsr-group">';
					output += '<div class="lsr-group-title">Class Actions</div><ul>';
					$.each(results.class_actions, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(results.posts.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="lsr-group">';
					output += '<div class="lsr-group-title">Insights</div><ul>';
					$.each(results.posts, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(!opt.type) {
					output += '<button type="button" class="clear-btn lsr-submit-btn"><span class="btn-label">Search site for “' + el.val() + '”</span><span class="btn-icon"><i class="far fa-search"></i></span></button>';
				}

				resultsEl.html(output);
				btnIcon.removeClass('fa-spinner-third fa-spin');
			});

			resultsEl.fadeIn(200);
		}
    };

}(jQuery));

jQuery(function($){
	// Search on header
	let headerSearchWrap = $('.header-search-wrap');
	let headerSearchForm = $('.header-search-wrap form');
	let headerSearchBtn = $('.header-search-btn');
	let headerSearchField = $('.header-search-keyword');
	headerSearchBtn.on('click', function(e){
		if($(window).width() >= 1200) {
			e.preventDefault();
			if(headerSearchWrap.hasClass('expanded')) {
				if(headerSearchField.val()) {
					submitSearch();
				} else {
					closeSearch();
				}
			} else {
				openSearch();
			}
		}
	});
	function openSearch() {
		headerSearchWrap.addClass('expanded');
		setTimeout(function(){
			$('.header-search-keyword').focus();
		}, 250);
	}
	function closeSearch() {
		headerSearchWrap.removeClass('expanded');
		$('.header-search-wrap .live-search-results').empty().hide();
	}
	function submitSearch() {
		headerSearchForm.submit();
	}
	$(window).on('click', function() {
		closeSearch();
	});
	$('.header-search-wrap').on('click', function(event){
	  event.stopPropagation();
	});

	headerSearchField.autoKomplete();
	$('.header-search-wrap').on('click', '.lsr-submit-btn', submitSearch);


	// Search on homepage hero
	$('.homepage-hero-searchform-wrap .keyword').autoKomplete();
	$('.homepage-hero-searchform-wrap').on('click', function(event){
	  event.stopPropagation();
	});

	// Hide live search results when user clicks the "X" button to clear the search field
	$('.homepage-hero-searchform-wrap .search-btn').on('click', function(){
		$('.homepage-hero-searchform-wrap form').addClass('no-live-search-results');
		$('.homepage-hero-searchform-wrap .live-search-results').empty().hide();
	});

	$('.homepage-hero-searchform-wrap .keyword').on('focus', function(){
		if(!$(this).val()) {
			$('.homepage-hero-searchform-wrap form').addClass('no-live-search-results');
		}
	});
	$(window).on('click', function() {
		$('.homepage-hero-searchform-wrap .live-search-results').empty().hide();
		$('.homepage-hero-searchform-wrap form').removeClass('no-live-search-results');
	});

	// Search on interior hero
	if($('.hero-live-search-enabled').length) {
		$('.hero-live-search-enabled .keyword').autoKomplete({ type: $('.hero-live-search-enabled').data('type') });
		$('.hero-live-search-enabled').on('click', function(event){
		  event.stopPropagation();
		});
		$(window).on('click', function() {
			$('.hero-live-search-enabled .live-search-results').empty().hide();
		});
	}

});


// Filters & ajax results
jQuery(function($){
	if($('.listing-filters').length) {

		const theForm = $('.listing-filters form');
		theForm.on('submit', function(e){

			e.preventDefault();
			let target = theForm.attr('action');
			let fieldsData = theForm.find(":input").filter(function() {
				return $.trim(this.value).length > 0
			}).serialize();

			window.history.replaceState('', '', fieldsData ? target + '?' + fieldsData : target);

			if(fieldsData) {
				theForm.addClass('filtered');
				target = target + '?' + fieldsData;
			} else {
				theForm.removeClass('filtered');
			}

			let holderSelector = '.ajax-results-wrap';
			let holder = $(holderSelector);

			holder.addClass('loading');
			holder.append(`
				<div class="spinner-wrap">
				<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
				</div>
				</div>
			`);

			$.get(target, function(response){
				let entries = $(response).find(holderSelector).children();
				holder.empty().removeClass('loading').append(entries);
			});

			$('#filters').collapse('hide');

		});


		$('.listing-filters select').on('change', function(){
			theForm.submit();
		});

		$('.listing-filters .clear-filter').on('click', function(e){
			e.preventDefault();
			theForm.find('input:not(.prevent-reset)').val('');
			theForm.find('select').prop('selectedIndex', 0).selectric('refresh');
			theForm.submit();
		});
	}

	$('.ajax-search-form').on('click', '.clear-filter-btn', function(e){
		e.preventDefault();
		let theForm = $(this).closest('form');
		theForm.find('input').val('');
		theForm.submit();
		$(this).removeClass('clear-filter-btn').attr('type', 'submit');
		console.log('xxx');
	});

	$('.ajax-search-form').on('submit', function(e){
		e.preventDefault();
		let target = $(this).attr('action') + '?' + $(this).serialize();
		$(this).find('button').attr('type', 'reset').addClass('clear-filter-btn');

		let holderSelector = '.ajax-results-wrap';
		let holder = $(holderSelector);

		holder.addClass('loading');
		holder.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.empty().removeClass('loading').append(entries);
		});

		$(this).find('.live-search-results').empty().hide();

		$('.listing-filters form').removeClass('filtered');
		$('.listing-filters form input').val();
		$('.listing-filters form select').prop('selectedIndex', 0).selectric('refresh');

	});


	// Load more ajax global
	$('.ajax-results-wrap').on('click', '.ajax-more a', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let thisBtnWrap = $(this).closest('.ajax-more');
		let holderSelector = '.ajax-holder';
		let holder = $(holderSelector);

		thisBtnWrap.addClass('loading');
		thisBtnWrap.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.append(entries);
			thisBtnWrap.remove();
			let generatedBtnWrap = $(response).find('.ajax-more');
			if(generatedBtnWrap.length) {
				generatedBtnWrap.insertAfter(holder);
			}
		});

	});

	// Search filters
	$('.hero-searchpage-links a').on('click', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		$('.hero-searchpage-links li').removeClass('current-menu-item');
		$(this).closest('li').addClass('current-menu-item');

		let holderSelector = '.ajax-results-wrap';
		let holder = $(holderSelector);

		holder.addClass('loading');
		holder.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.empty().removeClass('loading').append(entries);
		});

		window.history.replaceState('', '', target);
	});

});


// Random content
jQuery(function($){
	$('.featured-experience-band .featured-experience-items').each(function(){
		var jsonURL = ajax_var.rest_url + 'jgl/v1/rand_exp';
		var $this = $(this);

		const breakpoint = window.matchMedia( '(min-width:768px)' );
		var expSwiper;

		const breakpointChecker = function() {
			// if larger viewport and multi-row layout needed
			if ( breakpoint.matches === true ) {
				// clean up old instances and inline styles when available
				if ( expSwiper !== undefined ) expSwiper.destroy( true, true );
				// or/and do nothing
				return;
			// else if a small viewport and single column layout needed
			} else if ( breakpoint.matches === false ) {
				// fire small viewport version of swiper
				return enableSwiper();
			}
		};
		const enableSwiper = function() {
			expSwiper = new Swiper('.featured-experience-band .swiper', {
				loop: true,
				slidesPerView: 1,
				modules: [ Pagination, Manipulation ],
				speed: 700,
				spaceBetween: 0,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
		};

		breakpoint.addListener(breakpointChecker);
		breakpointChecker();


		$.getJSON(jsonURL, (results) => {
			if(results.items.length) {
				$.each(results.items, function(i, v){
					if ( expSwiper !== undefined ) {
						expSwiper.appendSlide(v);
					} else {
						$this.append(v);
					}
				});
			}
		});
	});

	$('.fc-random-testimonial').each(function(){
		var $this = $(this);
		var jsonURL = ajax_var.rest_url + 'jgl/v1/testimonial?pid=' + $this.data('pid') + '&idx=' + $this.data('idx');

		$.getJSON(jsonURL, (results) => {
			if(results.items.length) {
				$this.addClass('ajax-done').find('.testimonial-js-wrap').html(results.items[0]);
			}
		});
	});
});


const newsSlider = document.querySelectorAll('.related-news-band .swiper, .news-insights-band .swiper');
newsSlider.forEach(wrapper => {

	const breakpoint = window.matchMedia( '(min-width:768px)' );
	let newsSwiper;

	const breakpointChecker = function() {
		// if larger viewport and multi-row layout needed
		if ( breakpoint.matches === true ) {
			// clean up old instances and inline styles when available
			if ( newsSwiper !== undefined ) newsSwiper.destroy( true, true );
			// or/and do nothing
			return;
		// else if a small viewport and single column layout needed
		} else if ( breakpoint.matches === false ) {
			// fire small viewport version of swiper
			return enableSwiper();
		}
	};
	const enableSwiper = function() {
		newsSwiper = new Swiper(wrapper, {
			loop: true,
			slidesPerView: 1,
			modules: [ Pagination ],
			speed: 700,
			spaceBetween: 30,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	};

	breakpoint.addListener(breakpointChecker);
	breakpointChecker();

});
